/** Shared constants and helpers for Create/Edit tenant forms (banners + remote storage). */

import type { RemoteStorageType } from '@/shared/types';

export const REMOTE_STORAGE_OPTIONS: { value: '' | RemoteStorageType; label: string }[] = [
  { value: '', label: 'None' },
  { value: 'GoogleDrive', label: 'Google Drive' },
  { value: 'OneDrive', label: 'OneDrive' },
  { value: 'SharePoint', label: 'SharePoint' },
];

const REMOTE_STORAGE_URL_REQUIRED =
  'Remote storage URL is required when a remote storage type is selected.';

export function validateRemoteStorage(
  remoteStorageType: RemoteStorageType | undefined,
  remoteStorageUrl: string | undefined
): string | null {
  const hasType = !!remoteStorageType;
  if (hasType && !remoteStorageUrl?.trim()) return REMOTE_STORAGE_URL_REQUIRED;
  return null;
}

/** Filter empty banner URLs and remove remote_storage fields when type is not set. */
export function sanitizeBannersAndRemoteStorage<T extends { banners: string[]; remote_storage_type?: RemoteStorageType; remote_storage_url?: string }>(
  payload: T
): T {
  const out = { ...payload, banners: payload.banners.filter((u) => u.trim() !== '') };
  if (!out.remote_storage_type) {
    delete (out as Record<string, unknown>).remote_storage_type;
    delete (out as Record<string, unknown>).remote_storage_url;
  }
  return out as T;
}
